import { render, staticRenderFns } from "./chatgpt.vue?vue&type=template&id=5199b6a5&scoped=true"
import script from "./chatgpt.vue?vue&type=script&lang=js"
export * from "./chatgpt.vue?vue&type=script&lang=js"
import style0 from "./chatgpt.vue?vue&type=style&index=0&id=5199b6a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5199b6a5",
  null
  
)

export default component.exports